import FormError from './form-error.model';
import { BITCOIN_DECIMAL_PLACES_FORMAT, format} from '@shared/utils/number.utils';

import numeral from 'numeral';
import { DEFAULT_DECIMAL_FORMAT } from '../../../../../shared/utils/number.utils';

// TODO Change this to SubtransactionForm to avoid confusion with api models.
export class SubTransaction {
  constructor(key) {
    this.key = key;

    // NOTE: This is actually customer product.
    this.product = null;
    this.amount = 0;

    this.btc = 0;
    this.receiverAddress = null;

    this.customerProducts = [];
  }

  convertBtcToAmount(btcAdjustedRate) {
    let converted = numeral(btcAdjustedRate * this.btc);
    this.amount = format(converted, DEFAULT_DECIMAL_FORMAT);
  }

  convertAmountToBtc(btcAdjustedRate) {
    let converted = numeral(this.amount / btcAdjustedRate);
    this.btc = format(converted, BITCOIN_DECIMAL_PLACES_FORMAT);
  }

  get formattedBtc() {
    return format(numeral(this.btc), BITCOIN_DECIMAL_PLACES_FORMAT);
  }

  get formattedAmount() {
    return format(numeral(this.amount), BITCOIN_DECIMAL_PLACES_FORMAT);
  }

  get customerProductDisplay() {
    let customerProduct = this.customerProducts.filter(customerProduct => {
      return customerProduct.id === this.product;
    })[0];

    return `${customerProduct.product.name} (${customerProduct.username})`;
  }
}

export class TransactionForm {
  constructor(customerProducts, paymentOptions) {

    this.email = null;
    this.amount = null;
    this.file = null;
    this.paymentOption = null;
    this.subTransactions = [];
    this.customerProducts = customerProducts;
    this.paymentOptions = paymentOptions;
    this.paymentOptionType = null;

    this.selectedCustomerProducts = [];

    this.error = new FormError();
    this.nextItemKey = 0;

    // This becomes true when the customer comes from France coz we loved France so much.
    this.feeFree = false;
    this.feeMultiplier = null;

    this.props = { 
      readOnly: false ,
      isSubmitting: false,
      isReady: false,
    }

    this.addSubTransaction();
    // Some extra vars for updating views
    this.formViews = {
      isBank: false,
      isEcopayz: false,
      isSkrill: false,
      isNeteller: false,
    };
  }

  addSubTransaction() {
    let subTransaction = new SubTransaction(this.nextItemKey);
    let shallowCopy = this.customerProducts.slice(0); //copy by value not reference.
    shallowCopy = shallowCopy.filter(item => !this.selectedCustomerProducts.includes(item.id));
    subTransaction.customerProducts = shallowCopy;

    if (this.customerProducts.length === 1) {
      subTransaction.product = this.customerProducts[0].id;
    }

    this.subTransactions.push(subTransaction);
    this.nextItemKey++;

    return subTransaction;
  }

  addPredefinedSubTransaction(productId) {
    let subTransaction = new SubTransaction(this.nextItemKey);
    let shallowCopy = this.customerProducts.slice(0); //copy by value not reference.
    shallowCopy = shallowCopy.filter(item => !this.selectedCustomerProducts.includes(item.id));
    subTransaction.customerProducts = shallowCopy;
    subTransaction.product = +productId;

    this.subTransactions.push(subTransaction);
    this.nextItemKey++;
  }

  removeSubTransaction(subTransaction, index) {
    this.removeFromSelectedProducts(subTransaction.product);
    this.reloadToAllCustomerProducts(subTransaction.product, index);

    for (let i = 0; i < this.subTransactions.length; i++) {
      if (this.subTransactions[i].key === subTransaction.key) {
        this.subTransactions.splice(i, 1);
        break;
      }
    }
  }

  get totalAmount() {
    let totalAmount = numeral(0);

    angular.forEach(this.subTransactions, (subTransaction) => {
      totalAmount.add(subTransaction.amount);
    });

    return totalAmount.format('0.00');
  }

  get totalAmountToSend() {
    let totalAmount = numeral(this.totalAmount);
    totalAmount = totalAmount.add(this.fee);

    return totalAmount.format('0.00');
  }
  
  get totalAmountToBeDeposited() {
    let actualFee = this.paymentOptionType === 'BANK' ? this.bankFee : this.fee;
    let totalAmount = Number(this.totalAmount);
    actualFee = Number(actualFee);
    totalAmount = totalAmount + actualFee;

    return totalAmount;
  }

  get fee() {
    if (this.feeFree) {
      return 0;
    }

    let actualFee = numeral(this.totalAmount * this.feeMultiplier);

    return actualFee.format('0.00');
  }

  get bankFee() {
    if (this.totalAmount >= 2000) {
      return 0;
    }

    let bankFee = .01;
    let actualFee = this.totalAmount * Number(bankFee);

    if (this.totalAmount >= 201) {
      actualFee = 15;
    }

    return actualFee;
  }

  get isValid() {
    return this.subTransactions.length > 0;
  }

  get canAddProduct() {
    return this.customerProducts.length > 1;
  }

  get isBitcoin() {
    return this.paymentOptionType === 'BITCOIN';
  }

  get isEcopayz() {
    return this.paymentOptionType === 'ECOPAYZ';
  }

  get isNeteller() {
    return this.paymentOptionType === 'NETELLER';
  }

  get isSkrill() {
    return this.paymentOptionType === 'SKRILL';
  }

  get isBank() {
    return this.paymentOptionType === 'BANK';
  }

  get isReadOnly() {
    return this.props.readOnly;
  }
  
  reset() {
    this.amount = null;

    this.error = new FormError();
    this.nextItemKey = 0;

    // TODO: Should we reset this also?
    this.props.readOnly = false;
    this.props.isSubmitting = false;
    this.props.isReady = false;

    this.subTransactions = [];
    this.selectedCustomerProducts = [];
    
    this.addSubTransaction();
  }

  clearError() {
    this.error = new FormError();
  }

  toPayload() {
    let payload = {
      transaction: {
        email: this.email,
        paymentOptionType: this.paymentOptionType,
        file: this.file instanceof Array || this.file instanceof FileList ? this.file[0] : this.file,
      }
    };

    payload['transaction']['paymentOption'] = this.paymentOption;
    payload['transaction']['customerFee'] = this.paymentOptionType === 'BANK' ? this.bankFee : this.fee;

    let subTransactions = {};

    for (let subTransaction of this.subTransactions) {
      subTransactions[subTransaction.key] = {
        product: subTransaction.product,
        amount: subTransaction.amount
      };
    }

    payload['transaction']['subTransactions'] = subTransactions;

    if (this.file !== null) {
        payload = this.getBankPayload(payload);
    }

    return payload;
  }

  getBankPayload(payload) {
      const formData = new FormData();

      formData.append('transaction[email]', payload.transaction.email);
      formData.append('transaction[paymentOptionType]', payload.transaction.paymentOptionType);
      formData.append('transaction[file]', payload.transaction.file);
      formData.append('transaction[paymentOption]', payload.transaction.paymentOption);
      formData.append('transaction[customerFee]', payload.transaction.customerFee);

      angular.forEach(payload.transaction.subTransactions, (subTransaction, key) => {
        let index = 'transaction[subTransactions][' + key + ']';

        formData.append(index + '[product]', subTransaction.product);
        formData.append(index + '[amount]', subTransaction.amount);
      });

      return formData;
  }

  //============================================================================
  //  Code Below handles operations when a change in product selection occurs.
  //============================================================================
  onChangedCustomerProduct(index, newValue, oldValue) {
    this.selectedCustomerProducts.push(newValue);
    this.removeFromSelectedProducts(oldValue);
    this.removeFromSelection(newValue, index);
    this.reloadToAllCustomerProducts(oldValue, index);
  }

  removeFromSelection(newValue, index) {
    // Remove CustomerProduct with id matching the newValue within each SubTransactions
    for (let [sIndex, subTransaction] of this.subTransactions.entries()) {
      // This condition will not remove the CustomerProduct from the owning SubTransaction.
      // The reason is that, when we tried to remove it, the ng-model will be affected does
      // will unselect the selection. Apparently, this is the same implementation on OLD AMS.
      if (index !== sIndex) {
        for (let [cIndex, customerProduct] of this.subTransactions[sIndex].customerProducts.entries()) {
          if (customerProduct.id === newValue) {
            this.subTransactions[sIndex].customerProducts.splice(cIndex, 1);
          }
        }
      }
    }
  }

  removeFromSelectedProducts(value) {
    if (value) {
      let oldValueIndex = this.selectedCustomerProducts.indexOf(value);
      this.selectedCustomerProducts.splice(oldValueIndex, 1);
    }
  }

  // Push CustomerProduct with id matching the oldValue (if oldValue is not null) within each SubTransactions
  reloadToAllCustomerProducts(oldValue, index) {
    if (oldValue) {
      let oldCustomerProduct = this.getCustomerProductById(oldValue);
      for (let [sIndex, subTransaction] of this.subTransactions.entries()) {
        if (index !== sIndex) {
          subTransaction.customerProducts.push(oldCustomerProduct);
        }
      }
    }
  }

  getCustomerProductById(id) {
    return this.customerProducts.filter(customerProduct => customerProduct.id === id)[0];
  }
}



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/component/form/transactionform.model.js